import React from "react";
import { Row } from "react-bootstrap";
import styles from "./styles.module.scss";

function Loaders() {
  return (
    <Row className={styles.container}>
      <div className={styles.titleCard}></div>
      <div className={styles.subTitleCard}></div>
    </Row>
  );
}

export default Loaders;
